<template>
    <div class="mt-8 py-2">
        <div @click="close()" class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100">
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold mb-1 pb-2 mx-2">{{ trans.search_box.floor_guide }}</div>
            <div class="btn btn-sm rounded-full normal-case z-100" @click="clearAllFilter(), clickedMainCategory = false, active.all_locations = true">
                {{ trans.search_box.clear }}
            </div>
        </div>
        <div class="">
            <div class="flex mx-3 my-1 items-center" :class="{ 'hidden': currentState == 'half' }">
                <div class="relative w-full z-110">
                    <div class="absolute z-10 mt-2 mb-1 ml-2 text-base-content opacity-60 m-search-input">
                        <span class="material-symbols-outlined notranslate fill-current" v-if="!showList" @click="showList = true, isFilterOpen = false">
                            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="28px" height="28px"><path d="M 13 3 C 7.4889971 3 3 7.4889971 3 13 C 3 18.511003 7.4889971 23 13 23 C 15.396508 23 17.597385 22.148986 19.322266 20.736328 L 25.292969 26.707031 A 1.0001 1.0001 0 1 0 26.707031 25.292969 L 20.736328 19.322266 C 22.148986 17.597385 23 15.396508 23 13 C 23 7.4889971 18.511003 3 13 3 z M 13 5 C 17.430123 5 21 8.5698774 21 13 C 21 17.430123 17.430123 21 13 21 C 8.5698774 21 5 17.430123 5 13 C 5 8.5698774 8.5698774 5 13 5 z"/></svg>
                        </span>
                        <span class="material-symbols-outlined notranslate fill-current" v-if="showList" @click="handleBackButton">
                            <svg width="28px" height="28px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"/><path fill="#000000" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"/></svg>
                        </span>
                    </div>
                    <div class="absolute z-10 right-0 mb-1 mt-2 mr-2 text-base-content opacity-60 m-search-input" v-if="search.length > 0" @click="clearSearchInput(), isShowSuggestions = false, active.all_locations = true">
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 -960 960 960" width="28px"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                        </span>
                    </div>
                    <input
                        type="text"
                        name="search"
                        autocomplete="off"
                        placeholder="Search…"
                        class="input w-full input-bordered input-ml"
                        v-model.trim="search"
                        @focus="showList = true, clickedMainCategory = false, isFilterOpen = false, toTop()"
                        @keyup="onKeyUp"
                        @keydown="onKeyDown"
                        @input="handleSearchInput"

                    />
                </div>
                <div class="relative ml-1" @click="toggleFilter(), clickedMainCategory = false">
                    <span class="absolute inline-flex rounded-full h-3 w-3 bg-primary -top-1 -right-1" v-if="isFiltered"></span>
                    <div class="flex">
                        <div class="btn btn-square ml-1 normal-case">
                            <span class="material-symbols-outlined notranslate fill-current">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"/></svg>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-2 z-110 relative" :class="{ hidden: !showSearch, 'transition-all duration-200': true }">
                <div class="text-center relative" :class="{ hidden: showList || clickedShowResult || isFilterOpen, 'transition-all duration-200': true }">
                    <div v-if="mainCategories.length > 3" class="hidden sm:block">
                        <button v-if="showScrollLeftButton" @click="scrollToLeft(-100)" class="absolute left-0 cate_top btn btn-sm btn-ghost btn-active btn-circle z-110" style="top: 1.5rem;">❮</button>
                        <button v-if="showScrollRightButton" @click="scrollToLeft(100)" class="absolute right-0 cate_top btn btn-sm btn-ghost btn-active btn-circle z-110" style="top: 1.5rem;">❯</button>
                    </div>
                    <div class="mx-2 z-100">
                        <div @scroll="checkScrollButtons" ref="scrollContainer" class="carousel carousel-center bg-base-100 rounded-box w-full" >
                            <div class="carousel-item btn btn-ghost flex flex-col flex-nowrap justify-start items-center p-0 m-1 min-w-20 rounded-none border-base-content border-base-content border border-2 inline-flex min-h-full my-2 py-1 pb-3 hover:bg-base-100"
                                :class="{ 'text-base-content active-border': active.all_locations, 'text-base-content/60': !active.all_locations }"
                                @click="chooseQuick(true ,'all_locations')"
                                title="Show all location">
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="32" viewBox="0 -960 960 960" width="32"><path d="M480-118 120-398l66-50 294 228 294-228 66 50-360 280Zm0-202L120-600l360-280 360 280-360 280Zm0-280Zm0 178 230-178-230-178-230 178 230 178Z"></path></svg>
                                </span>
                                <span class="text-xs normal-case">{{ trans.search_box.all }}</span>
                            </div>
                            <div v-for="category in mainCategories"
                                :key="'search-cate-' + category.id"
                                :class="{ 'text-base-content active-border': active.category.main == category.id, 'text-base-content/60': active.category.main != category.id }"
                                @click="handleClickedMainCategory(category)"
                                class="carousel-item btn btn-ghost flex flex-col flex-nowrap justify-start items-center p-0 m-1 min-w-20 rounded-none border-base-content border-base-content border border-2 inline-flex min-h-full my-2 py-1 pb-3 hover:bg-base-100"
                                >
                                <img :src="category.icon_url" alt="" loading="lazy" class="inline w-8">
                                <span class="text-xs normal-case">{{ category.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="my-0 mx-2">
            <div id="parcel-title" class="menu top-0 sticky"
                style="background-color: #fff;"
                :class="{ 'hidden': isShowSuggestions || showList || isFilterOpen }">
                <div class="flex">
                    <div class="text-base-content text-sm mx-2 font-extrabold mb-1">{{ parcelTitle }}</div>
                </div>
            </div>
            <div class="results" v-if="isShowSuggestions && suggestions.length > 0">
                <div class="overflow-y-auto h-screen search-content-height">
                    <table class="table mt-2">
                        <tbody>
                            <tr
                                class="hover"
                                :class="{
                                    highlight: isHighlightClass && index == hoverSuggestion
                                }"
                                v-for="(suggestion, index) in suggestions"
                                :key="'search-suggestion' + index"
                                @mousedown="chooseSuggestion(suggestion)"
                                @mouseover="
                                    hoverSuggestion = index;
                                    isHighlightClass = true;
                                "
                                @mouseleave="isHighlightClass = false"
                                style="border-bottom-style: solid"
                            >
                                <td>
                                    <div class="flex items-center gap-3">
                                        <span class="material-symbols-outlined notranslate fill-current">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                                        </span>
                                        <div
                                            class="text-base-content text-sm break-words"
                                            style="overflow-wrap: anywhere"
                                        >
                                            {{ suggestion }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="text-center mt-2 mx-4" v-if="suggestions.length >= 20">
                        <div class="font-bold mb-2">{{ trans.search_box.show_maximum }}</div>
                    </div>
                    <div class="text-center my-4 mx-4">
                        <button class="btn btn-circle" v-if="suggestions" @click="isShowSuggestions = false">
                            <span class="material-symbols-outlined notranslate fill-current">
                                <svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"/><path fill="#000000" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"/></svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="floor-guide-container" class="overflow-y-auto h-screen search-content-height">
            <div class="">
                <div class="mb-96 sm:mb-20 pb-48">
                    <div v-if="showList">
                        <div class="" v-if="mainCategories.length > 0">
                            <div class="mt-2 mx-4 flex items-center justify-end">
                                <button class="btn btn-square btn-sm btn-ghost" v-if="showList" @click="handleBackButton">
                                    <span class="material-symbols-outlined notranslate fill-current">
                                        <svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"/><path fill="#000000" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"/></svg>
                                    </span>
                                </button>
                            </div>
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.floor }}</span>
                                </li>
                                <div>
                                    <div class="flex flex-wrap my-3 layers-container">
                                        <a
                                            v-for="layer in layers"
                                            :key="'btn-layer-' + layer.id"
                                            class="btn join-item btn-outline btn btn-sm gap-2 normal-case bg-base-100 mb-2 ml-2"
                                            :class="{ 'btn-active': currentLayer.id == layer.id }"
                                            @click="changeLayer(layer), showList = false"
                                            :href="'#layer-div-' + layer.id"
                                            style="border: 2px solid;"
                                            :id="'btn-layer-' + layer.id"
                                        >
                                            {{ layer.shortened_title }}
                                        </a>
                                    </div>
                                </div>
                                <li class="menu-title">
                                    <span>{{ trans.search_box.category }}</span>
                                </li>
                                <li :class="(clickedMainCategory && selectedMainCategory.id == category.id) || !clickedMainCategory ? '' : 'hidden'"
                                    v-for="category in mainCategories"
                                    :key="'search-cate-' + category.id"
                                >
                                    <details v-if="category.lower_category_ids.length > 0"
                                        :open="(clickedMainCategory && selectedMainCategory.id == category.id) || category.lower_category_ids.includes(active.category.sub) ? true : false">
                                        <summary open>
                                            <div class="flex items-center gap-3">
                                                <div class="avatar">
                                                    <div class="mask w-6 h-6">
                                                        <img :src="category.icon_url" alt="" />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="font-bold">{{ category.title }}</div>
                                                </div>
                                            </div>
                                        </summary>
                                        <ul>
                                            <template v-for="itemId in category.lower_category_ids">
                                                <li :key="'search-cate-' + itemId" v-if="categories[itemId]">
                                                    <div class="flex items-center gap-3" :for="'search-cate-' + itemId"
                                                        :class="{ 'bg-base-200': active.category.sub == categories[itemId].id }"
                                                        @click="chooseQuick(categories[itemId], 'category');">
                                                        <div class="avatar">
                                                            <div class="mask w-6 h-6">
                                                                <img :src="categories[itemId].icon_url" alt="" />
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div class="font-bold">{{ categories[itemId].title }}</div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </details>
                                    <div class="flex items-center gap-3" v-else
                                        :class="{ 'bg-base-200': active.category.main == category.id }"
                                        @click="chooseQuick(category, 'category');">
                                        <div class="avatar">
                                            <div class="mask w-6 h-6">
                                                <img :src="category.icon_url" alt="" />
                                            </div>
                                        </div>
                                        <div>
                                            <div class="font-bold">{{ category.title }}</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div :class="!clickedMainCategory ? '' : 'hidden'" v-if="itemResource.length > 0">
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.item }}</span>
                                </li>
                                <li v-for="item in itemResource" :key="'search-item-' + item.id">
                                    <div class="flex items-center gap-3"
                                        :class="{ 'bg-base-200': quickSearch.item == item.id }"
                                        @click="chooseQuick(item, 'item');">
                                        <div class="avatar">
                                            <div class="mask w-6 h-6">
                                                <img :src="item.image_url" alt="" />
                                            </div>
                                        </div>
                                        <div>
                                            <div class="font-bold">{{ item.title }}</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div :class="!clickedMainCategory ? '' : 'hidden'" v-if="facilityResource.length > 0">
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.facility }}</span>
                                </li>
                                <template v-for="facility in facilityResource">
                                    <li v-if="!facility.is_hidden_on_parcel"
                                        :key="'search-facility-' + facility.id">
                                        <div class="flex items-center gap-3"
                                            :class="{ 'bg-base-200': quickSearch.facilities.includes(facility.id) }"
                                            @click="chooseQuick(facility, 'facilities');">
                                            <div class="avatar">
                                                <div class="mask w-6 h-6">
                                                    <img :src="facility.image_url" alt="" />
                                                </div>
                                            </div>
                                            <div>
                                                <div class="font-bold">{{ facility.title }}</div>
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </div>
                        <div class="text-center mt-4 mx-4">
                            <button class="btn btn-circle" v-if="showList" @click="handleBackButton">
                                <span class="material-symbols-outlined notranslate fill-current">
                                    <svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"/><path fill="#000000" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"/></svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="description" style="padding-top: 0px;">
                        <div v-if="isFilterOpen" :class="{ 'hidden': isShowSuggestions || showList }">
                            <div class="overflow-y-auto h-screen search-content-height">
                                <div class="mx-2">
                                    <div class="mb-96 sm:mb-20 pb-48">
                                        <div class="" v-if="categoryData.length > 0">
                                            <div class="mb-1 mt-5 mx-2 flex items-center">
                                                <button class="btn btn-square btn-sm btn-ghost" @click="clickLocationsFound(), clickedMainCategory = false">
                                                    <span class="material-symbols-outlined notranslate fill-current">
                                                        <svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"/><path fill="#000000" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"/></svg>
                                                    </span>
                                                </button>
                                                <div class="text-base font-extrabold ml-1">{{ trans.search_box.filter }}</div>
                                            </div>
                                            <form name="sampleform">
                                                <ul class="menu overflow-visible">
                                                    <li class="menu-title">
                                                        <span>{{ trans.search_box.category }}</span>
                                                    </li>
                                                    <li v-for="category in mainCategories" :key="'search-cate-' + category.id">
                                                        <label class="label cursor-pointer whitespace-pre-line"
                                                            :for="'cate-id-' + category.id"
                                                            @click="handleCheckBox"
                                                        >
                                                            <span class="label-text">
                                                                <span
                                                                    v-show="category.lower_category_ids.length > 0"
                                                                    class="fas span-fas"
                                                                    @click="toggleTreeView(category.id, 'category')"
                                                                    :class="treeViewCategory['child_of_' + category.id]
                                                                        ? 'fa-minus-square'
                                                                        : 'fa-plus-square'
                                                                    "
                                                                    >&nbsp;</span
                                                                >{{ category.title }}</span
                                                            >
                                                            <input
                                                                :id="'cate-id-' + category.id"
                                                                type="checkbox"
                                                                class="checkbox checkbox-primary"
                                                                :value="category.id"
                                                                v-model="filter.categories"
                                                                @change="checkClickAllCategory(category, $event)"
                                                            />
                                                        </label>
                                                        <ul
                                                            class="pl-0 ml-2"
                                                            v-if="category.lower_category_ids.length > 0"
                                                            v-show="treeViewCategory['child_of_' + category.id]"
                                                        >
                                                            <template v-for="itemId in category.lower_category_ids">
                                                                <li :key="'search-cate-' + itemId" v-if="categories[itemId]">
                                                                    <label class="label cursor-pointer whitespace-pre-line" :for="'cate-id-' + itemId">
                                                                        <span class="label-text">{{
                                                                            categories[itemId].title
                                                                        }}</span>
                                                                        <input
                                                                            :id="'cate-id-' + itemId"
                                                                            type="checkbox"
                                                                            class="checkbox checkbox-primary"
                                                                            :value="categories[itemId].id"
                                                                            v-model="filter.categories"
                                                                        />
                                                                    </label>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                        <!-- level3 -->
                                                    </li>
                                                </ul>
                                                <p class="allcheck my-2 justify-end card-actions justify-end">
                                                    <input
                                                        type="button"
                                                        :value="trans.search_box.select_all"
                                                        @click="allCheckCategories(true)"
                                                    />
                                                    <input
                                                        type="button"
                                                        :value="trans.search_box.clear"
                                                        @click="allCheckCategories(false)"
                                                    />
                                                </p>
                                            </form>
                                            <div class="divider my-1"></div>
                                        </div>
                                        <div class="" v-if="itemResource.length > 0">
                                            <form name="sampleform">
                                                <ul class="menu overflow-visible">
                                                    <li class="menu-title">
                                                        <span>{{ trans.search_box.item }}</span>
                                                    </li>
                                                    <li v-for="item in itemResource" :key="'search-item-' + item.id">
                                                        <label class="label cursor-pointer">
                                                            <span class="label-text">{{ item.title }}</span>
                                                            <input
                                                                type="radio"
                                                                class="radio radio-primary"
                                                                :value="item.id"
                                                                v-model="filter.item"
                                                            />
                                                        </label>
                                                    </li>
                                                </ul>
                                                <p class="allcheck my-2 justify-end card-actions justify-end">
                                                    <input
                                                        type="button"
                                                        :value="trans.search_box.clear"
                                                        @click="filter.item = ''"
                                                    />
                                                </p>
                                            </form>
                                            <div class="divider my-1"></div>
                                        </div>
                                        <div class="" v-if="facilityResource.length > 0">
                                            <form name="sampleform">
                                                <ul class="menu overflow-visible">
                                                    <li class="menu-title">
                                                        <span>{{ trans.search_box.facility }}</span>
                                                    </li>
                                                    <template v-for="facility in facilityResource">
                                                    <li v-if="!facility.is_hidden_on_parcel"
                                                        :key="'search-facility-' + facility.id"
                                                    >
                                                        <label class="label cursor-pointer">
                                                            <span class="label-text">{{ facility.title }}</span>
                                                            <input
                                                                type="checkbox"
                                                                class="checkbox checkbox-primary"
                                                                :value="facility.id"
                                                                v-model="filter.facilities"
                                                            />
                                                        </label>
                                                    </li>
                                                    </template>
                                                </ul>
                                                <p class="allcheck my-2 justify-end card-actions justify-end">
                                                    <input
                                                        type="button"
                                                        :value="trans.search_box.clear"
                                                        @click="filter.facilities = []"
                                                    />
                                                </p>
                                            </form>
                                            <div class="divider my-1"></div>
                                        </div>
                                        <div class="">
                                            <div class="grid grid-cols-1 gap-2 mt-5">
                                                <button class="absolute bottom-12 bottom-sp inset-x-0 btn mx-3 normal-case z-20 drop-shadow-lg button-position"
                                                    :class="{ 'btn-primary': numberOfResult > 0 }"
                                                    @click="clickLocationsFound(), clickedMainCategory = false;">
                                                    <div v-if="numberOfResult > 0">
                                                        <div class="flex items-center">
                                                            <div class="badge">{{ numberOfResult }}</div>
                                                            <div class="ml-1">{{ trans.search_box.found_results }}</div>
                                                        </div>
                                                        <div v-if="numberOfResult > 100">
                                                            <div class="text-opacity-80 text-xs font-weight-100">{{ trans.search_box.large_results }}</div>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="text-base-content text-sm">{{ trans.search_box.no_results_found }}</div>
                                                    </div>
                                                </button>
                                                <button class="btn btn-link btn-block" @click="close()">
                                                    {{ trans.search_box.show_map }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-0 detail" :class="{ 'hidden': currentState == 'half' }">
                            <div class="overflow-y-auto h-screen py-0 pb-20 search-content-height"
                                @scroll="handleScroll"
                                :class="{ 'hidden': isShowSuggestions || showList }"
                            >
                                <table class="table menu overflow-visible p-0 floor-content-height" >
                                    <tbody v-show="numberOfResult > 0" v-for="layer in layers" :key="'li-layer-' + layer.id" style="display: block;">
                                        <div class="menu sticky z-10 bg-base-200 space-x-2 custom-sticky-li layer-element py-2"
                                            style="border-left: solid 7px; border-bottom: solid 1px;"
                                            :layer-id="layer.id"
                                            :id="'layer-div-' + layer.id">
                                            <div class="flex items-center p-0">
                                                <div class="btn btn-neutral btn-xs w-10">{{ layer.shortened_title }}</div>
                                                <div class="px-2 py-0 w-full">
                                                    <div class="font-bold text-base-content">{{ layer.title }}</div>
                                                    <div class="float-right">
                                                    <template v-for="layerFacility in layer.layer_facilities">
                                                        <span v-if="layerFacility.show_floor_guide" class="material-symbols-outlined layer-facility-image ml-1"
                                                            :key="'span-layer-facility' + layerFacility.id">
                                                            <img :src="layerFacility.image_url">
                                                        </span>
                                                    </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-for="(location, index) in locationList">
                                            <tr :key="location.properties.id"
                                                @click="changeLocationDetail(location)"
                                                v-if="location.properties.layer_id == layer.id"
                                                :layer-id="layer.id"
                                                class="w-full hover inline-block">
                                                <td class="flex items-center space-x-2">
                                                    <div class="">
                                                        <div class="mask mask-squircle bg-base-content h-16 w-16 bg-opacity-10 p-px">
                                                            <img class="mask mask-squircle w-full h-full object-cover bg-primary"
                                                                :src="location.properties.marker_image_url">
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="text-sm font-bold break-words text-overflow-wrap">{{ location.properties.title }}</div>
                                                        <div class="text-base-content/70 text-xs break-words text-overflow-wrap mb-1">{{ location.properties.sub_title }}</div>
                                                        <p class="btn btn-xs disabled rounded-full normal-case">{{ location.properties.category.title }}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-show="numberOfResult == 0" style="display: block;">
                                        <div class="menu sticky z-10 bg-base-300 space-x-2 custom-sticky-li py-2">
                                            <div class="flex items-center p-0">
                                                <div class="text-base-content text-sm px-2">{{ trans.search_box.no_results_found }}</div>
                                            </div>
                                        </div>
                                        <!-- apply sticky top to no_results. PLEASE DO NOT REMOVE IT! -->
                                        <tr class="w-full inline-block pt-25rem">
                                            <td class="flex items-center space-x-2">
                                                <div class="h-16"></div>
                                            </td>
                                        </tr>
                                        <!-- end apply sticky top to no_results. PLEASE DO NOT REMOVE IT! -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['trans'],
    props: {
        locationResource: {
            type: Array,
            required: true
        },
        itemResource: {
            type: Array,
            required: true
        },
        facilityResource: {
            type: Array,
            required: true
        },
        categoryData: {
            type: Array,
            required: true
        },
        numberOfResult: {
            type: Number
        },
        currentTag: {
            type: String
        },
        locationList: {
            type: Array,
            required: true,
        },
        currentLayer: {
            type: Object,
            default: function() {
                return null
            }
        },
        currentState: {
            type: String,
            default: ''
        },
        layers: {
            type: Array,
            required: true
        },
        parcelTitle: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            search: '',
            suggestions: [],
            hoverSuggestion: '',
            isHighlightClass: false,
            isShowSuggestions: false,
            filter: {
                keyword: '',
                categories: [],
                item: '',
                facilities: [],
            },
            isFilterOpen: false,
            showSearch: true,
            prevScrollTop: 0,
            showList: false,
            threshold: 5,
            clickedMainCategory: false,
            selectedMainCategory: {},
            isFiltered: false,
            showScrollLeftButton: false,
            showScrollRightButton: true,
            scrollContainer: null,
            clickedShowResult: false,
            clickedSuggestion: false,
            keyDownCode: null,
            treeViewCategory: {},
            quickSearch: {
                categories: [],
                item: '',
                facilities: [],
            },
            active: {
                category: {
                    main: '',
                    sub: '',
                },
                facility: '',
                item: '',
                all_locations: true,
            },
            nextlayerId: '',
        };
    },
    computed: {
        titlesAndTags() {
            let results = [];
            this.locationResource.forEach((element) => {
                const properties = element.properties;
                let found = results.find((element) => element.name == properties.name);
                if (!found) {
                    results.push({ id: properties.id, name: properties.title });
                }
                properties.tags.forEach((tag) => {
                    let found = results.find((element) => element.name == tag);
                    if (!found) {
                        results.push({ id: properties.id, name: tag });
                    }
                });
            });

            return results.sort(function (a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            });
        },
        mainCategories() {
            return this.categoryData.filter(
                (cat) =>
                    cat.lower_category_ids.length > 0 || !cat.upper_category_id
            );
        },
        categories() {
            var categories = {};
            this.categoryData.forEach((element, index) => {
                categories[element.id] = element;
                if (element.lower_category_ids.length > 0) {
                    this.$set(this.treeViewCategory, 'child_of_' + element.id, true);
                }
            });
            return categories;
        }
    },
    methods: {
        close() {
            this.isShowSuggestions = false;
            this.showList = false;
            this.isFilterOpen = false;
            this.$emit('closed');
        },
        chooseSuggestion(payload) {
            this.triggerEventGA('searched_keyword', {
                id: payload,
                title: payload
            });
            this.search = payload;
            this.isShowSuggestions = false;
            this.clickedSuggestion = true;
        },
        allCheckCategories(type) {
            if (type) {
                this.filter.categories = [];
                this.categoryData.forEach((item) => {
                    this.filter.categories.push(item.id);
                });
            } else {
                this.filter.categories = [];
            }
        },
        toggleTreeView(payload, type) {
            switch (type) {
                case 'category':
                    this.treeViewCategory['child_of_' + payload] = !this.treeViewCategory['child_of_' + payload];
                    break;
            }
        },
        clearAllFilter() {
            this.allCheckCategories(false);
            this.filter = {
                keyword: '',
                categories: [],
                item: '',
                facilities: [],
            };
            this.clearSearchInput();
            this.clearQuickSearch();
            this.clearActive();
            this.clickedShowResult = false;
        },
        clearSearchInput() {
            this.search = '';
        },
        clickLocationsFound() {
            this.isFilterOpen = false;
            this.clickedShowResult = true;
        },
        handleSearchInput() {
            if (this.search === '') {
                this.resetSuggestions();
            }
        },
        resetSuggestions() {
            this.suggestions = [];
        },
        toggleFilter() {
            this.isFilterOpen = !this.isFilterOpen;
            if (this.isFilterOpen) {
                this.showList = false;
                this.isShowSuggestions = false;
                this.clickedShowResult = false;
            }
            this.clearAllFilter();
            this.toTop();
        },
        handleScroll(event) {
            let mainNavLinks = event.target.querySelectorAll('.layer-element');

            const element1 = document.getElementById('parcel-title');
            const rect1 = element1.getBoundingClientRect();
            const scrollTop = event.target.scrollTop;
            mainNavLinks.forEach(link => {
                var rect2 = link.getBoundingClientRect();
                if (!(rect1.bottom < rect2.top)) {
                    if (!this.showList) {
                        mainNavLinks.forEach(li => {
                            li.classList.remove('bg-base-300');
                            li.classList.add('bg-base-200');
                        });
                        link.classList.add('bg-base-300');
                        link.classList.remove('bg-base-200');
                        this.nextlayerId = link.getAttribute('layer-id');
                    }
                }
            });

            if (scrollTop > this.prevScrollTop + this.threshold) {
                this.showSearch = false;
            } else if (scrollTop < this.prevScrollTop - this.threshold) {
                this.showSearch = true;
            }

            this.prevScrollTop = scrollTop;
        },
        scrollToLeft(value) {
            this.scrollContainer.scrollLeft += value;
            this.checkScrollButtons();
        },
        checkScrollButtons() {
            setTimeout(() => {
                this.showScrollLeftButton = this.scrollContainer.scrollLeft > 0;
                this.showScrollRightButton = this.scrollContainer.scrollLeft < this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
            }, 0);
        },
        getScrollContainer() {
            this.scrollContainer = this.$refs.scrollContainer;
        },
        clearQuickSearch() {
            this.quickSearch = {
                categories: [],
                item: '',
                facilities: [],
            };
        },
        onKeyDown(event) {
            if (this.keyDownCode === null) {
                this.keyDownCode = event.keyCode
            }
        },
        onKeyUp(event) {
            if (event.keyDown != 13) {
                this.handleResult();
            }

            if (this.keyDownCode !== null) {
                if (this.keyDownCode == 13 && event.keyCode == 13) {
                    // ENTER KEY IS PRESSED!!!
                    this.isShowSuggestions = false;
                }
                this.keyDownCode = null
            }
        },
        handleResult() {
            this.clearActive();
            this.isFilterOpen = false;
            if (this.suggestions.length > 0) {
                this.showList = false;
                this.isShowSuggestions = true;
            } else {
                this.showList = false;
                this.isShowSuggestions = false;
            }
        },
        isOnCurrentLayer(layerId) {
            return this.currentLayer && this.currentLayer.id == layerId
        },
        changeLocationDetail(payload) {
            if (this.clickedSuggestion) {
                this.clickedSuggestion = false;
            }
            this.$emit('closed');
            this.$emit('changedLocationDetail', payload);
            this.$emit('isOpenedFloorGuideBox', true);
            if (payload.properties.layer_id && !this.isOnCurrentLayer(payload.properties.layer_id)) {
                let foundLayer = this.layers.find((element) => element.id == payload.properties.layer_id);
                this.$emit('changedLayer', foundLayer);
            }
        },
        handleClickedMainCategory(cat) {
            this.clickedMainCategory = true;
            this.selectedMainCategory = cat;
            this.chooseQuick(cat, 'category');
        },
        chooseQuick(val, type, ancestorId = '') {
            // type = 1: cate, 2: item, 3: facility
            this.clearAllFilter();
            this.showList = false;
            switch (type) {
                case 'category':
                    this.quickSearch.categories.push(val.id);
                    if (!val.upper_category_id) {
                        val.lower_category_ids.forEach((id) => {
                            this.quickSearch.categories.push(id);
                        });
                        this.active.category.main = val.id;
                        this.active.category.sub = '';
                    } else {
                        this.active.category.main = val.upper_category_id;
                        this.active.category.sub = val.id;
                    }
                    break;
                case 'item':
                    this.quickSearch.item = val.id;
                    this.active.item = val.id;
                    break;
                case 'facilities':
                    this.quickSearch.facilities.push(val.id);
                    break;
                case 'all_locations':
                    this.active.all_locations = true;
                    break;
            }
            this.toTop();
        },
        toTop() {
            document.getElementById('floor-guide-container').scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        hirakana (str) {
            return str.replace(/[ァ-ヶ]/g, function (c) {
                return String.fromCharCode(c.charCodeAt(0) - 0x60)
            })
        },
        katakana (str) {
            return str.replace(/[ぁ-ん]/g, function (c) {
                return String.fromCharCode(c.charCodeAt(0) + 0x60)
            })
        },
        handleBackButton() {
            this.showList = false;
        },
        checkClickAllCategory(category, event) {
            if (category.lower_category_ids.length == 0) return;

            category.lower_category_ids.forEach((id) => {
                const indexOf = this.filter.categories.indexOf(id);
                if (indexOf == -1 && event.target.checked) {
                    this.filter.categories.push(id);
                }
                if (indexOf != -1 && !event.target.checked) {
                    this.filter.categories.splice(indexOf, 1);
                }
            });
        },
        handleCheckBox(event) {
            if (event.target.classList.contains('span-fas')) {
                event.preventDefault();
            }
        },
        clearActive() {
            this.active = {
                category: {
                    main: '',
                    sub: '',
                },
                facility: '',
                item: '',
                all_locations: false,
            };
        },
        changeLayer(payload) {
            this.$emit('changedLayer', payload);
        }
    },
    mounted() {
        this.getScrollContainer();
    },
    watch: {
        search(newVal) {
            var invalid = /[^a-zA-Z0-9\s]+/g;
            var sanitizedNewval = newVal.replace(invalid, '\\$&');
            this.filter.keyword = sanitizedNewval;
            var hirakanaNewVal = this.hirakana(sanitizedNewval);
            var katakanaNewVal = this.katakana(sanitizedNewval);
            if (!newVal) return;

            let results = [];
            const pattern = new RegExp(`${sanitizedNewval}`, 'i');
            const hirakanaPattern = new RegExp(`${hirakanaNewVal}`, 'i');
            const katakanaPattern = new RegExp(`${katakanaNewVal}`, 'i');
            let total = this.titlesAndTags.length;
            let n = 0;
            for (let i = 0; i < total; i++) {
                if (n >= 20) break;
                const item = this.titlesAndTags[i].name;
                if (item.search(pattern) != -1 || item.search(hirakanaPattern) != -1 || item.search(katakanaPattern) != -1) {
                    results.push(item);
                    n++;
                }
            }
            this.suggestions = results;
        },
        filter: {
            handler: function (newVal) {
                this.$emit('filtered', newVal);
                if (['checkbox', 'radio'].includes(event.target.type)) {
                    this.clearSearchInput();
                }
                if (this.clickedSuggestion && this.numberOfResult == 1) {
                    this.changeLocationDetail(this.locationList[0]);
                }

                if (newVal.categories.length || newVal.item || newVal.facilities.length) {
                    this.isFiltered = true;
                } else {
                    this.isFiltered = false;
                }
            },
            deep: true
        },
        currentTag(newVal) {
            this.search = newVal;
            this.$emit('toggledSubSidebar', 'floorGuideBox');
        },
        quickSearch: {
            handler: function (newVal) {
                this.$emit('filtered', newVal);
            },
            deep: true
        },
        nextlayerId(payload) {
            let foundLayer = this.layers.find((element) => element.id == payload);
            this.changeLayer(foundLayer);
        }
    }
};
</script>


<style scoped>
.input-ml {
    padding-left: 40px;
    padding-right: 40px;

}
.search-content-height {
    padding-bottom: 41rem;
}
.button-position {
    width: -moz-available;
}
.active-border{
    border-bottom: 2px solid;
}
.font-weight-100{
    font-weight: 100;
}
.m-search-input{
    margin-top: 10px;
}
.z-110{
    z-index: 110;
}
@media screen and (max-width: 639px) {
    .search-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
    .button-position {
        position: static;
    }
    .bottom-sp {
        position: static;
    }
    .button-position {
        position: fixed;
        padding-bottom: env(safe-area-inset-bottom);
        bottom: 12px;
    }
}
.floor-content-height {
    padding-bottom: 25rem;
}
.menu.active {
  background-color: var(--bg-base-300)!important;
}
.layer-facility-image {
    width: 24px;
    height: 24px;
}
.custom-sticky-li {
    z-index: 10;
    width: 100%;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: flex-start;
    top: -1px;
    pointer-events: none;
}
.pt-25rem{
    padding-top: 25rem;
}
.min-w-20{
    min-width: 5rem;
}
</style>